/* eslint-disable no-use-before-define */
import React from 'react'
import { Detail } from './detail'
import { Loading } from './loading'
import { NotFound } from './not-found'
import { getIssueData } from './get-issue-data'

export const Loader = ({cusip, offers, showTradeHistory, showBackLink, showBondDetail, isTreasuryAuction, from}) => {

    const [status, setStatus] = React.useState('loading')
    const [issueData, setIssueData] = React.useState(null)

    React.useEffect(() => {
        let cancelled = false

        ;(async () => {
            let data_ = await getIssueData(cusip)
            if (cancelled) return

            if (data_===undefined) {
                setStatus('failed')
                return
            }

            if (!data_) {
                setStatus('not-found')
                return
            }

            setStatus('found')
            setIssueData(Object.assign({showTradeHistory, showBackLink, showBondDetail, isTreasuryAuction, from}, offers, data_))
        })()

        return () => {
            cancelled = true
        }
    }, [])

    return <React.Fragment>
        { status==='loading' ? <Loading />
        : status==='not-found' ? <NotFound />
        : status==='found' ? <Detail {...issueData} />
        : null }
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/twd/format/issuer/loader.js